module.exports = __webpack_public_path__ + "static/media/inventory-reports-summary.4b6521b0.png";